export default __webpack_public_path__ + "static/media/project6.a522a368.jpg";